export default "__VITE_ASSET__CDSmjovb__"